import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseurl+"auth/";

const login = async (username, password) => {
    try {
        const response = await axios.post(API_URL + "login", { username, password });
        if (response.data.token) {
            localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to login');       
    }
};

const register = async (companyName, address, primaryPhone, email, password) => {
    try {
        const response = await axios.post(BaseUrl.baseurl + "api/customers/create", {
            companyName,
            address,
            primaryPhone,
            email,
            password,
        });
        return response.data;
    } catch (error) {
        // backend sends plain-text responses, not JSON
        const data = error.response?.data;
        const message = typeof data === 'string' ? data : (data?.message || 'Failed to sign up');
        throw new Error(message);
    }
};

const logout = () => {
    const user = getCurrentUser();
    axios.post(BaseUrl.baseurl + "logout", null, {
            headers: {
                'Authorization': `Bearer ${user.token}`
            }
        });

    localStorage.removeItem("user");
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
};

const AuthService = {
    login,
    register,
    logout,
    getCurrentUser,
};

export default AuthService;